import React, { useEffect, useState } from "react";

import { css } from "@emotion/css";
import {
  desktop,
  laptop,
  tablet,
} from "../../../styles/breakpoints";
import Frame1 from "../../../img/png/tech/frame-1.png";
import Frame2 from "../../../img/png/tech/frame-2.png";
import Frame3 from "../../../img/png/tech/frame-3.png";
import Frame4 from "../../../img/png/tech/frame-4.png";
import Frame5 from "../../../img/png/tech/frame-5.png";
import Frame6 from "../../../img/png/tech/frame-6.png";
import Frame7 from "../../../img/png/tech/frame-7.png";
import Frame8 from "../../../img/png/tech/frame-8.png";
import Frame9 from "../../../img/png/tech/frame-9.png";
import Frame10 from "../../../img/png/tech/frame-10.png";
import { useI18n } from "../../../i18n";

const Anazlysis = () => {
  const { t } = useI18n();
  const [frame, setFrame] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setFrame(frame < 10 ? frame + 1 : 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [frame]);

  return (
    <div className={style.container}>
      <h2>{t("tech_analysis")}</h2>
      <div className="animation">
        <img src={Frame1} alt="" style={{ opacity: frame === 1 ? 1 : 0 }} />
        <img src={Frame2} alt="" style={{ opacity: frame === 2 ? 1 : 0 }} />
        <img src={Frame3} alt="" style={{ opacity: frame === 3 ? 1 : 0 }} />
        <img src={Frame4} alt="" style={{ opacity: frame === 4 ? 1 : 0 }} />
        <img src={Frame5} alt="" style={{ opacity: frame === 5 ? 1 : 0 }} />
        <img src={Frame6} alt="" style={{ opacity: frame === 6 ? 1 : 0 }} />
        <img src={Frame7} alt="" style={{ opacity: frame === 7 ? 1 : 0 }} />
        <img src={Frame8} alt="" style={{ opacity: frame === 8 ? 1 : 0 }} />
        <img src={Frame9} alt="" style={{ opacity: frame === 9 ? 1 : 0 }} />
        <img src={Frame10} alt="" style={{ opacity: frame === 10 ? 1 : 0 }} />
      </div>
      <p>
        {t("tech_analysis_body")}
      </p>
    </div>
  );
};

const style = {
  container: css({
    width: "100%",
    position: "relative",
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(167deg, rgba(0, 0, 0, 0.00) 35.37%, #000 82.59%), #6744FF',
    paddingTop: 100,
    paddingBottom: 0,
    overflow: 'hidden',

    h2: {
      color: '#fff',
      fontFamily: 'Syne',
      fontSize: 120,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '140px',
      textTransform: 'uppercase',
      maxWidth: 800,
      textAlign: 'left',
      position: 'absolute',
      top: '0%',
      left: '10%'
    },
    p:{
      color: '#FFF',
      fontFamily: 'Inter',
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      letterSpacing: 0.36,
      maxWidth: 510,
      position: 'absolute',
      bottom: '15vh',
      right: '10%'
    },
    ".animation": {
      position: "relative",
      width: 1583,
      height: 1168,

      img: {
        position: "absolute",
        width: '100%',
        transition: 'all 2s',
        height: 'auto'
      },
    },

    [desktop]: {
      h2: {
        fontSize: 75,
        lineHeight: '80px',
        maxWidth: 800,
        top: '0%',
        left: '5%'
      },
      p:{
        fontSize: 18,
        bottom: '15%',
        right: '10%'
      },
      ".animation": {
        width: 1128.17,
        height: 832.409,

        img: {
          position: "absolute",
          width: '100%',
          transition: 'all 2s',
          height: 'auto'
        },
      },
    },
    [laptop]: {
      h2: {
        fontSize: 65,
        lineHeight: 'normal',
        maxWidth: 700,
        top: '0%',
        left: '5%'
      },
      p:{
        maxWidth: 651,
        fontSize: 18,
        bottom: '5%',
        right: 0,
        left: 0,
        margin: 'auto'
      },
      ".animation": {
        width: 1128.17,
        height: 832.409,

        img: {
          position: "absolute",
          width: '100%',
          transition: 'all 2s',
          height: 'auto'
        },
      },
    },
    [tablet]: {
      paddingBottom: 160,
      paddingTop: 120,

      h2: {
        maxWidth: 335,
        fontSize: 42,
        lineHeight: '50px',
        top: '0%',
        left: '0%',
        padding: 20,
      },
      p:{
        maxWidth: 324,
        fontSize: 14,
        bottom: '5%',
        padding: 20,
      },
      ".animation": {
        width: 513,
        height: 379,

        img: {
          position: "absolute",
          width: '100%',
          transition: 'all 2s',
          height: 'auto'
        },
      },
    },
  }),
};

export default Anazlysis;
